<template>
    <div class="datepicker-trigger">

        <slot></slot>

        <airbnb-style-datepicker :trigger-element-id="triggerId"
            :close-after-select="true"
            :inline="inline"
            :show-shortcuts-menu-trigger="false"
            :show-action-buttons="false"
            :offset-y="10"
            :mode="'range'"
            :fullscreen-mobile="fullscreenMobile"
            :disabled-dates="disabledDays"
            :customized-dates="calClasses"
            :min-date="minDate"
            :end-date="maxDate"
            :date-one="from"
            :date-two="till"
            @opened="onOpened"
            @closed="onClosed"
            :mobile-header="mobileHeader"
            @date-one-selected="onFromSelected"
            @date-two-selected="onTillSelected" />
    </div>
</template>

<script>
    import {
    	isBlank
    }
    from 'voUtils/tools.js';
    import V from 'voUtils/V.js'


    import DateEx from 'voUtils/DateEx.js'

    export default {
    	voVueComponent: 'voffice-daterange',
    	voMsgCodes: [
    		'weekdayslist.short',
    		'monthlist.full',
    		'weekdayslist'
    	],
    	data() {
    		return {
    			needTill: false,
    			nextArrivalDate: undefined,
    			disabledArrivalDays: [],
    			disabledDepartureDays: [],
    			calClasses: [],
    			minStayValues: {},
    			priceValues: {},
    			personalSurcharge: undefined,
    			cal: undefined,
    			prices: undefined
    		}
    	},
    	props: {
    		from: String,
    		till: String,
    		triggerId: String,
    		inline: Boolean,
    		fullscreenMobile: Boolean,
    		getCal: Function,
    		toscroll: Boolean,
    		getPrices: Function
    	},
    	computed: {
    		disabledDays: function() {
    			return this.needTill ? this.disabledDepartureDays : this.disabledArrivalDays
    		},
    		mobileHeader: function() {
    			if (this.needTill) {
    				return this.voMsg("daterange.till");
    			} else {
    				return this.voMsg("daterange.from");
    			}
    		},
    		minDate: function() {
    			if (this.needTill) {
    				return DateEx.plusDays(this.from, 1);
    			} else {
    				return DateEx.interfaceFormat(DateEx.getToday());
    			}

    		},
    		maxDate: function() {
    			if (this.needTill) {
    				return this.nextArrivalDate;
    			} else {
    				return undefined;
    			}

    		}

    	},

    	methods: {
    		onOpened: function() {
    			if (this.getPrices && !this.prices) {
    				this.getPrices((prices) => {
    					this.prices = prices;

    					var from;
    					var till;
    					var diffDays;
    					var days;
    					var day;
    					var priceValues = {};
    					var services = {};
    					var personalSurcharge = null;


    					for (let a of prices.retailPrices) {
    						if (a.service.type === 'RENT' && a.service.surcharge && a.service.mandatory) {
    							if (a.guestRange && a.guestRange.min) {
    								if (!personalSurcharge) {
    									personalSurcharge = parseInt(a.guestRange.min) - 1;
    								}
    							}


    						}
    						for (let b of a.lines) {
    							if (b.type === 'RENT') {
    								from = DateEx.interfaceFormat(b.fromdate);
    								till = DateEx.interfaceFormat(b.tilldate);
    								days = DateEx.getDays(b.tilldate, b.fromdate) - 1;
    								day = DateEx.localDate(b.fromdate);
    								//console.log('Service::', a.service);
    								for (var i = 0; i <= days; i++) {
    									if (!a.service.surcharge) {
    										priceValues[DateEx.interfaceFormat(day)] = {};
    										priceValues[DateEx.interfaceFormat(day)]['price'] = b.value;
    										if (b.nightRange) {
    											priceValues[DateEx.interfaceFormat(day)]['minnights'] = b.nightRange.min
    										}
    									}
    									day = DateEx.plusDays(day, 1)
    								}
    							}
    						}
    					}


    					this.priceValues = priceValues;
    					this.personalSurcharge = personalSurcharge;


    				});


    			}
    			if (this.getCal && !this.cal) {
    				this.getCal((cal) => {
    					this.cal = cal;
    					var day = DateEx.localDate(cal.availabilityUpdate);

    					var arrivals = [];
    					var departures = [];
    					var notAvailable = [];
    					var minStayValues = {};

    					var last;
    					for (let a of cal.availability) {
    						if (a == 'Y') {
    							if (last == 'N' || last == 'Q') {
    								departures.push(DateEx.interfaceFormat(day));
    							}
    						} else {
    							if (last == 'Y') {
    								arrivals.push(DateEx.interfaceFormat(day));
    							} else {
    								notAvailable.push(DateEx.interfaceFormat(day));
    							}
    						}
    						day = DateEx.plusDays(day, 1)
    						last = a;
    					}

    					var day = DateEx.localDate(cal.availabilityUpdate);

    					for (let a of this.cal.minStay) {
    						minStayValues[DateEx.interfaceFormat(day)] = a;
    						day = DateEx.plusDays(day, 1)
    					}


    					this.minStayValues = minStayValues;

    					this.calClasses = [{
    						cssClass: 'arrival',
    						dates: arrivals
    					}, {
    						cssClass: 'departure',
    						dates: departures
    					}, {
    						cssClass: 'not-available',
    						dates: notAvailable
    					}];

    					var disabledArrivalDays = []
    					var day = DateEx.localDate(cal.availabilityUpdate);
    					if (cal.changeOver !== null) {
    						for (let a of cal.changeOver) {
    							if (a == 'X' || a == 'O') {
    								disabledArrivalDays.push(DateEx.interfaceFormat(day));
    							}
    							day = DateEx.plusDays(day, 1)
    						}
    					}

    					this.disabledArrivalDays = disabledArrivalDays;
    					var priceValues = this.priceValues;
    					this.makeTooltip();

    				});
    			}
    		},
    		onClosed: function() {

    			setTimeout(() => {
    				this.$emit('closed');
    			}, 50);
    		},
    		onFromSelected: function(d) {
    			this.needTill = true;
    			this.$emit('update:from', d);
    			this.$emit('update:till', undefined);

    			if (this.cal) {

    				//nextArrivalDate
    				let day = DateEx.localDate(this.cal.availabilityUpdate);
    				let from = DateEx.localDate(d);

    				let nextArrivalDate;
    				for (let a of this.cal.availability) {
    					if (day > from && a != 'Y') {
    						nextArrivalDate = day;

    						break;
    					}
    					day = DateEx.plusDays(day, 1);
    				}

    				this.nextArrivalDate = DateEx.interfaceFormat(nextArrivalDate);

    				day = DateEx.localDate(this.cal.availabilityUpdate);

    				var disabledDepartureDays = [];
    				for (let a of this.cal.changeOver) {
    					if (nextArrivalDate && day > nextArrivalDate) {
    						break;
    					} else if (day > from && (a == 'X' || a == 'I')) {
    						disabledDepartureDays.push(DateEx.interfaceFormat(day));
    					}
    					day = DateEx.plusDays(day, 1)
    				}

    				this.disabledDepartureDays = disabledDepartureDays;

    			}

    		},
    		onTillSelected: function(d) {
    			this.needTill = isBlank(d) && this.from;
    			this.$emit('update:till', d);
    			setTimeout(() => {
    				this.$emit('on-tilldate-selected');
    			}, 50);
    			/*console.log('1 value of toscroll is::' + this.toscroll);
    			if (!this.needTill && this.toscroll) {
    				console.log('value of toscroll is::' + this.toscroll);

    			}*/
    		},
    		makeTooltip: function() {


    			const that = this;
    			var minStayValues = this.minStayValues;
    			var priceValues = this.priceValues;
    			var personalSurcharge = this.personalSurcharge


    			var minstayText = this.voMsg("tpl.text.minstay");
    			var nightsText = this.voMsg("tpl.text.nights");
    			var fromText = this.voMsg("tpl.text.from");
    			var untilText = this.voMsg("tpl.text.until");
    			var personsText = this.voMsg("tpl.text.persons");
    			var occupiedText = this.voMsg("tpl.text.occupied");


    			$('body').on('mouseover', '.asd__day', function(e) {
    				var pickdate = ''
    				var title = '';
    				var price;
    				var cur = VOFFICE.currency || '&euro;';
    				var currency = cur.replace(/eur/i, "&euro;");
    				pickdate = $(this).attr('data-date');




    				if ($(this).hasClass('asd__day--not-available')) {
    					title += occupiedText;
    				} else {
    					if (minStayValues[pickdate]) {
    						title += minstayText + ": " + minStayValues[pickdate] + ' ' + nightsText;
    					}
    					if (that.priceValues[pickdate]) {
    						price = (Math.round((that.priceValues[pickdate].price / 100) * 100) / 100);
    						if (minStayValues[pickdate]) {
    							//title += "<br/>" + price.toLocaleString(undefined, {
    							//	minimumFractionDigits: 2,
    							//	maximumFractionDigits: 2
    							//}) + ' ' + currency;
    						} else {
    							//title += price.toLocaleString(undefined, {
    							//	minimumFractionDigits: 2,
    							//	maximumFractionDigits: 2,
    							//}) + ' ' + currency;
    						}
    						if (that.priceValues[pickdate].minnights) {
    							//title += " " + fromText + " " + that.priceValues[pickdate].minnights + ' ' + nightsText;
    							if (personalSurcharge) {
    								//title += "<br/>" + untilText + " " + personalSurcharge + ' ' + personsText;
    							}
    						} else {
    							if (personalSurcharge) {
    								//title += " " + untilText + " " + personalSurcharge + ' ' + personsText;
    							}
    						}
    					}
    				}


    				$(this).attr('data-title', title);
    				$(this).attr('data-toggle', 'tooltip');
    				$(this).attr('data-placement', 'top');
    				$(this).tooltip({
    					placement: "top",
    					html: true,
    					template: '<div class="tooltip datepicker" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
    				});
    				$(this).tooltip('show');
    			});


    			$('body').on('mouseout click', '.asd__day', function(e) {
    				$(this).tooltip('hide');
    			});


    		}
    	}
    }
</script>

<style scoped>
</style>